export default __webpack_public_path__ + "static/media/edit.d74a4bd6.svg";